import { useRequest } from 'ahooks';
import { useEffect } from 'react';
import { useReadyInfo } from '@/providers/ReadyProvider';
import { fetchLoseBasic } from '@/services/site';

/**
 * 获取失物招领下拉框数据
 * - pick_team 拾到人所在团队
 * - item_type 物品类型
 * - deposit_addr 存放地点
 * - lose_status 服务状态
 */
const useLoseBasic = () => {
  const { loseBasic, setLoseBasic } = useReadyInfo();

  const { run: getLoseBasic, data, loading } = useRequest(fetchLoseBasic, { manual: true });

  useEffect(() => {
    if (
      !loseBasic ||
      !loseBasic?.pick_team ||
      !loseBasic?.lose_status ||
      !loseBasic?.deposit_addr ||
      !loseBasic?.item_type
    ) {
      getLoseBasic().then((res) =>
        setLoseBasic({
          pick_team:
            res?.pick_team?.map((v) => {
              return { label: v.name, value: v.id };
            }) ?? [],
          lose_status:
            res?.lose_status?.map((v) => {
              return { label: v.name, value: v.id };
            }) ?? [],
          deposit_addr:
            res?.deposit_addr?.map((v) => {
              return { label: v.name, value: v.id };
            }) ?? [],
          item_type:
            res?.item_type?.map((v) => {
              return { label: v.name, value: v.name };
            }) ?? [],
        })
      );
    }
  }, [loseBasic]);

  return {
    data: loseBasic || {
      pick_team:
        data?.pick_team?.map((v) => {
          return { label: v.name, value: v.id };
        }) ?? [],
      lose_status:
        data?.lose_status?.map((v) => {
          return { label: v.name, value: v.id };
        }) ?? [],
      deposit_addr:
        data?.deposit_addr?.map((v) => {
          return { label: v.name, value: v.id };
        }) ?? [],
      item_type:
        data?.item_type?.map((v) => {
          return { label: v.name, value: v.name };
        }) ?? [],
    },
    loading,
  };
};

export default useLoseBasic;
